(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/admin/react-dialog-wrapper/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/admin/react-dialog-wrapper/assets/javascripts/prescript.js');

svs.components = svs.components || {};
svs.components.dialogWrapper = svs.components.dialogWrapper || {};



 })(window);